export default __webpack_public_path__ + "static/media/telegram-qr-code.1e8d76c5.svg";